export default "__VITE_ASSET__DDlLuK$k__"